<script setup lang="ts">
import Icon from '@ui/components/icon/Icon.vue'
import AngleDown from '~icons/cue-regular/angle-down'

withDefaults(
  defineProps<{
    show?: boolean
  }>(),
  {
    show: false,
  },
)
</script>

<template lang="pug">
Icon.chevron(:name="AngleDown" :class="{ expanded: show }")
</template>

<style scoped>
.chevron {
  transition: transform 0.2s ease;

  &.expanded {
    transform: rotateX(180deg);
  }
}
</style>
